import { useState, useEffect } from "react";
import { Progress, Flex, Text } from "@radix-ui/themes";
import { useSurveyStore } from "@src/store/survey";

export default function SurveyProgress() {
  const [surveyProgress, setSurveyProgress] = useState(null);
  const currentSurveySection = useSurveyStore(
    (state) => state.currentSurveySection,
  );
  const surveySections = useSurveyStore((state) => state.surveySections);

  useEffect(() => {
    if (currentSurveySection && surveySections) {
      const currentSectionIndex = surveySections?.surveys?.findIndex(
        (section) => section.slug === currentSurveySection,
      );
      setSurveyProgress(currentSectionIndex);
    } else {
      setSurveyProgress(0);
    }
  }, [currentSurveySection, surveySections]);

  return (
    <Flex maxWidth="100px" width="100px" align="center" gap="1">
      <Text size="1" color="indigo">
        {surveyProgress + 1} / {surveySections?.surveys?.length}
      </Text>
      <Progress
        value={surveyProgress}
        size="2"
        max={surveySections?.surveys?.length - 1}
      />
    </Flex>
  );
}
